import { Button } from "@9amhealth/shared";
import type { FC } from "react";
import { IconArrowDown, IconClose } from "src/constants/icons";
import translate from "src/lib/translate";
import type { TranslationKey } from "src/types/translationKey";
import Translate from "src/ui/components/Translate/Translate";
import {
  Actions,
  CloseButton,
  CoachingSheet,
  Content,
  Description,
  Footnote,
  Header,
  Headline,
  Tile,
  TileLabel,
  TileUnit,
  TileValue,
  TileValueRow,
  Tiles,
  TrendIcon,
  UpperSection
} from "./CoachingBenefitsModal.styled";
import { VideoCallCollage } from "./VideoCallCollage";

const BENEFIT_TILES: { value: string; label: TranslationKey }[] = [
  { value: "36.2", label: "coachingBenefits.tile.withCoaching" },
  { value: "23.4", label: "coachingBenefits.tile.withoutCoaching" }
];

interface CoachingBenefitsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFindTime: () => void;
  onSkip?: () => void;
}

export const CoachingBenefitsModal: FC<CoachingBenefitsModalProps> = ({
  isOpen,
  onClose,
  onFindTime,
  onSkip
}) => (
  <CoachingSheet
    isOpen={isOpen}
    onClose={onClose}
    trackingName="Coaching Benefits Modal"
    overlayDragHandle
    desktopFullscreen
  >
    <CloseButton
      type="button"
      onClick={onClose}
      aria-label={translate("close")}
    >
      <IconClose />
    </CloseButton>

    <Content>
      <UpperSection>
        <VideoCallCollage />
        <Header>
          <Headline>
            <Translate msg="coachingBenefits.headline" />
          </Headline>
          <Description>
            <Translate msg="coachingBenefits.description" />
          </Description>
        </Header>
      </UpperSection>

      <Tiles>
        {BENEFIT_TILES.map(({ value, label }) => (
          <Tile key={label}>
            <TileValueRow>
              <TrendIcon>
                <IconArrowDown />
              </TrendIcon>
              <TileValue>{value}</TileValue>
              <TileUnit>
                <Translate msg="coachingBenefits.tile.unit" />
              </TileUnit>
            </TileValueRow>
            <TileLabel>
              <Translate msg={label} />
            </TileLabel>
          </Tile>
        ))}
      </Tiles>

      <Actions>
        <Button theme="charcoal" grow onPress={onFindTime}>
          <Translate msg="coachingBenefits.cta.findTime" />
        </Button>
        {onSkip && (
          <Button theme="simple" hideArrow center onPress={onSkip}>
            <Translate msg="coachingBenefits.cta.skip" />
          </Button>
        )}
      </Actions>

      <Footnote>
        <Translate msg="coachingBenefits.footnote" />
      </Footnote>
    </Content>
  </CoachingSheet>
);
